import PaginaQuestionario from '../components/paginaQuestionario/PaginaQuestionario.vue'
import {createRouter, createWebHistory} from 'vue-router'  

var routes = [{
    path: '/',
    component: PaginaQuestionario
},
{
  path: '/di-cosa-hai-bisogno/',
  component: PaginaQuestionario
},
{
  path: '/di-cosa-hai-bisogno',
  component: PaginaQuestionario
}

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
    switch(to.path){
        default:
            next()
    }
  })



export default router